"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchPiece = void 0;
var MatchPiece_1 = require("./MatchPiece");
Object.defineProperty(exports, "MatchPiece", { enumerable: true, get: function () { return MatchPiece_1.MatchPiece; } });
